import { memo } from 'react';

import { IcAlbumIcon } from '@gem/icons';
import { IconView } from '@gem/ui-kit';

import SelectedText from '../../SelectedText';
import styles from './styles.m.scss';

const Album = ({ message }) => {
  return (
    <>
      <IconView
        Icon={IcAlbumIcon}
        size="small"
        className={styles.icon}
      />
      <SelectedText {...message.textChunk} />
    </>
  );
};

export default memo(Album);
